// One operation owner for term moves and category mutations. A confirmed write
// is never reported as a rejected write merely because refreshing failed.
export function createDirectoryManagement({api, refresh}) {
  let snapshot = {busy: false, needsRefresh: false};
  const listeners = new Set();
  const publish = patch => { snapshot = {...snapshot, ...patch}; listeners.forEach(fn => fn()); };
  async function load() {
    const state = await refresh();
    if (!state) throw Error('清單未載入，請確認連線後重新整理。');
    publish({needsRefresh: false}); return state;
  }
  async function mutate(path, body) {
    if (snapshot.busy || snapshot.needsRefresh) return null;
    publish({busy: true});
    try {
      const value = await api(path, 'POST', body);
      try { return {saved: true, value, state: await load(), warning: ''}; }
      catch { publish({needsRefresh: true}); return {saved: true, value, state: null, warning: '變更已儲存，但清單未載入；請重新整理清單後再操作。'}; }
    } finally { publish({busy: false}); }
  }
  return {
    getSnapshot: () => snapshot,
    subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
    move: payload => mutate('categories/terms/move', payload),
    category: payload => mutate('admin/categories', payload),
    async refresh() {
      if (snapshot.busy) return null;
      publish({busy: true});
      try { return await load(); } finally { publish({busy: false}); }
    },
    history: () => api('admin/categories/history')
  };
}

export function validMoveSelection({terms, catalog, termId, targetId, beforeId, assignable}) {
  const term = terms.find(t => t.id === termId), items = catalog.items;
  const target = items.find(c => c.id === targetId && assignable(c)) ||
    items.find(c => c.name === term?.category && assignable(c)) || items.find(assignable);
  const validBefore = target?.id === targetId && terms.some(t => t.id === beforeId && t.id !== termId && t.category === target.name);
  return {target: target?.id || '', before: validBefore ? beforeId : ''};
}
